import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const categories = [
  {
    id: 'hot',
    name: 'Hot Drinks',
    image: 'https://images.unsplash.com/photo-1610478506025-8110cc8f1986?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHx0ZWElMjBjdXB8ZW58MHx8fHwxNzcxMDY4NTIwfDA&ixlib=rb-4.1.0&q=85',
    count: '10+ items'
  },
  {
    id: 'snacks',
    name: 'Snacks',
    image: 'https://images.unsplash.com/photo-1630384060421-cb20d0e0649d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxmcmllc3xlbnwwfHx8fDE3NzEwNjg1Mzd8MA&ixlib=rb-4.1.0&q=85',
    count: '15+ items'
  },
  {
    id: 'shawarma',
    name: 'Shawarma',
    image: 'https://images.unsplash.com/photo-1662116765994-1e4200c43589?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxzaGF3YXJtYXxlbnwwfHx8fDE3NzEwNjg1MTZ8MA&ixlib=rb-4.1.0&q=85',
    count: '9 varieties'
  }
];

export const CategoriesSection = () => {
  return (
    <section className="section-padding bg-muted/50">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-4">
            Top Categories
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">
            Explore our most popular menu categories
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {categories.map((category) => (
            <Link 
              key={category.id} 
              to={`/menu?category=${category.id}`}
              className="group relative h-80 rounded-2xl overflow-hidden hover-scale"
            >
              {/* Image */}
              <div 
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                style={{ backgroundImage: `url(${category.image})` }}
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-primary via-primary/60 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />
              
              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-end p-6 text-primary-foreground">
                <h3 className="text-2xl font-display font-bold mb-2">{category.name}</h3>
                <p className="text-sm text-primary-foreground/80 mb-4">{category.count}</p>
                <Button 
                  variant="secondary" 
                  size="sm" 
                  className="w-fit"
                >
                  View More
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;